/**
 * input the "fileName" from api, ex: 1678963616217-this-item-might-not-exist2.svg
 */
export const isImage = (filename) => {
  if (!filename || typeof filename !== 'string') return false;
  const supportedImageExtensitons = ['gif', 'jpg', 'png', 'jpeg', 'svg'];
  const splitedFilename = filename.split('.');
  return supportedImageExtensitons.includes(
    splitedFilename[splitedFilename.length - 1].toLocaleLowerCase()
  );
};

// export const isKoreanPhoneNumber = (string) => {
//   const lengthPattern = /^010\\d{8}$/;
//   const koPhoneNumPattern = /^01(?:0|1|[6-9])-(\\d{3}|\\d{4})-(\\d{4})$/;
//   return koPhoneNumPattern.test(string) || lengthPattern.test(string);
// };

export const isEmail = (string) => {
  const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
  return emailPattern.test(string);
};

export const isValidDate = (date) => {
  // eslint-disable-next-line no-restricted-globals
  return date instanceof Date && !isNaN(date);
};

export const is11Number = (num) => {
  return num?.length === 11 && /^\d+$/.test(num);
};
export const isValidKoreanPhoneNumber = (phoneNumber) => {
  const mobileRegex = /^010\d{8}$/;
  const dashedMobileRegex = /^01(?:0|1|[6-9])-(\d{3}|\d{4})-(\d{4})$/;

  return mobileRegex.test(phoneNumber) || dashedMobileRegex.test(phoneNumber);
};



export const isValidPassword = (password) => {
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/;

  return passwordRegex.test(password);
};
